import { useQuery } from '@tanstack/react-query';

import { api } from '../../shared/api/client';
import { queryKeys } from '../../shared/api/queryKeys';

/**
 * Фильтры журнала — ровно те, что есть на экране (CAP-7). API умеет ещё `targetType` и
 * `target`, но неподключённый параметр — это обещание без экрана: вернутся вместе с
 * элементом интерфейса, который их выставляет.
 */
export type AuditFilters = {
  action?: string;
  actor?: string;
};

function query(filters: AuditFilters, cursor: string | undefined) {
  const params: Record<string, string> = {};
  if (filters.action) params.action = filters.action;
  if (filters.actor) params.actor = filters.actor;
  if (cursor) params.cursor = cursor;
  return params;
}

/** Страница журнала аудита (CAP-7). Ключ под префиксом `audit` — его инвалидирует смена роли (AD-A5). */
export function useAuditLog(filters: AuditFilters, cursor: string | undefined) {
  const params = query(filters, cursor);
  return useQuery({
    queryKey: queryKeys.audit.list(params),
    queryFn: () => api.get('/admin/audit-logs', { params: { query: params } }),
    placeholderData: (previous) => previous,
  });
}
